import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { useCreateStockCorrection } from '@/core/domain/stock/StockCorrections/StockCorrections.hooks';
import { PartStockPricesResult } from '@/core/domain/stock/StockItems/StockItems.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { useInventoryPartFormContext } from '@/pages/OperationalPages/InventoryPages/PartsPage/InventoryPartsProvider';
import { Col, Form, Modal, ModalProps, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  partStockPricesItem: PartStockPricesResult;
}

export default function PartsDetailsStockCorrectionStockModal({
  partStockPricesItem,
  ...props
}: Props) {
  const { partId } = useInventoryPartFormContext();

  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const [form] = Form.useForm<{ quantity: number; observation: string }>();

  const createStockCorrection = useCreateStockCorrection();

  const handleCancel = () => {
    props?.onCancel();
    form.resetFields();
  };

  const handleOk = async () => {
    const values = await form.validateFields();

    const result = await createStockCorrection.mutateAsync({
      companyId: partStockPricesItem.company.id,
      idempotentToken: '',
      observation: values.observation,
      items: [
        {
          oldQuantity: partStockPricesItem.stock,
          quantity: values.quantity,
          partId: Number(partId),
        },
      ],
    });

    window.open(
      `/app/movements/stockCorrections/${result.result.id}`,
      '_blank',
    );

    handleCancel();
  };

  return (
    <Modal
      title="Realizar correção de estoque"
      open={props.open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={createStockCorrection.isLoading}
      width={500}
    >
      <Form form={form}>
        <Row gutter={[16, 6]}>
          <Col span={12}>
            <FloatingFormItem label="Qtde. anterior">
              <InputDecimal disabled value={partStockPricesItem.stock} />
            </FloatingFormItem>
          </Col>

          <Col span={12}>
            <FloatingFormItem
              name="quantity"
              label="Nova qtde."
              rules={[
                defaultEmptyFieldError,
                {
                  type: 'number',
                  min: partStockPricesItem.reservedStock,
                  message: `Quantidade mínima reservada: ${partStockPricesItem.reservedStock}`,
                },
              ]}
              initialValue={1}
            >
              <InputDecimal fractions={2} min={0} />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem name="observation" label="Observação">
              <TextArea />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
